import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, FloatingInput, Notification, Title,
} from '@express-labs/raven-ui';
import { Formik, Form, Field } from 'formik';

import { validateEmail } from '../LoginForm/formValidation';
import s from './ForgotPasswordForm.module.scss'
import getInputErrors from '../../../../utils/getInputError';

function ForgotPasswordForm(props) {
  const {
    email,
    handleCurrentForm,
    handleFormSubmit,
    hasError,
    loading,
    showNotification,
  } = props;

  if (showNotification) {
    return (
      <div className={s.formDetails}>
        <Title tag="h2" className={s.title}>Thanks Please Check Your Inbox</Title>
        <p className={s.description}>
          An email has been sent to
          {' '}
          {email}
          {' '}
          with instructions and a link to reset your password. If
          you still have trouble logging in, please call (888) 397-1980 to talk with a customer
          service representative.
        </p>
        <Button
          as="button"
          mode="solid"
          size="large"
          theme="dark"
          className={s.backButton}
          aria-label="Press back button for login modal"
          data-testid="back-button"
          onClick={handleCurrentForm}
        >
          BACK TO LOGIN
        </Button>
      </div>
    );
  }

  return (
    <div className={s.formContainer}>
      <Title tag="h2" className={s.title}>
        Forgot your password?
      </Title>
      <p className={s.description}>We’ll send you a reminder email.</p>
      <Formik
        initialValues={{ email: '' }}
        onSubmit={handleFormSubmit}
      >
        {({ errors, touched }) => (
          <Form
            noValidate
          >
            {hasError && (
              <Notification
                color="red"
                text="We experienced an error trying to reset your password. Please try again."
              />
            )}
            <Field name="email" validate={validateEmail}>
              {({ field }) => {
                const inputErrors = getInputErrors({ touched, errors, inputName: 'email' });
                return (
                  <FloatingInput
                    className={s.email}
                    label="Email Address"
                    aria-label="Email Address"
                    required
                    errors={inputErrors}
                    data-qm-encrypt
                    {...field}
                />);
              }}
            </Field>
            <Button
              as="button"
              mode="solid"
              size="large"
              theme="dark"
              type="submit"
              className={s.resetPasswordButton}
              data-testid="reset-password"
              disabled={loading}
            >
              RESET PASSWORD
            </Button>
          </Form>
        )}
      </Formik>
    </div>
  );
}

ForgotPasswordForm.meta = {
  VERSION: '1.0.0',
};

ForgotPasswordForm.propTypes = {
  email: PropTypes.string,
  handleCurrentForm: PropTypes.func,
  handleEmailField: PropTypes.func,
  handleFormSubmit: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
  loading: PropTypes.bool,
  showNotification: PropTypes.bool,
};

ForgotPasswordForm.defaultProps = {
  email: '',
  handleCurrentForm: null,
  handleEmailField: null,
  hasError: false,
  loading: false,
  showNotification: false,
};

export default ForgotPasswordForm;
